import React, { memo, forwardRef } from "react";
const SvgAlphabetU = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.42 19.67c0 .267-.047.487-.14.66-.08.16-.18.287-.3.38a.906.906 0 01-.38.18c-.12.027-.227.04-.32.04s-.207-.013-.34-.04a.915.915 0 01-.36-.18 1.306 1.306 0 01-.32-.38 1.578 1.578 0 01-.12-.66v-.46h-.04c-.213.48-.587.907-1.12 1.28-.52.36-1.14.54-1.86.54-.627 0-1.167-.107-1.62-.32a3.415 3.415 0 01-1.1-.88 3.613 3.613 0 01-.62-1.24 5.214 5.214 0 01-.2-1.44v-4.84c0-.28.04-.507.12-.68a1.2 1.2 0 01.32-.42c.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v4.16c0 .28.02.573.06.88.04.307.127.587.26.84.133.24.313.44.54.6.24.16.553.24.94.24.373 0 .7-.073.98-.22.293-.16.527-.36.7-.6.187-.24.327-.513.42-.82.093-.32.14-.64.14-.96v-4.12c0-.28.04-.507.12-.68a1.2 1.2 0 01.32-.42c.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v7.36z"
      />
    </svg>
  );
});
SvgAlphabetU.displayName = "SvgAlphabetU";
const MemoForwardRef = memo(SvgAlphabetU);
export default MemoForwardRef;
